import * as React from 'react'

import { observer } from 'mobx-react'

import { Switch } from '~/client/src/shared/components/shadcn-ui/switch'

interface IProps {
  showInMap: boolean
  onToggle: (value: boolean) => void | Promise<void>
}

/**
 * Independent "Show in Map" toggle. Unlike the WR toggle it has no clear/enable
 * cascade and is not gated by isBookable — it only flips the location's display
 * flag. Mirrors WorkflowResourceCell's in-flight disable + unmount guard.
 */
function ShowInMapCell({ showInMap, onToggle }: IProps) {
  const [isSaving, setIsSaving] = React.useState(false)
  const isMountedRef = React.useRef(true)
  React.useEffect(
    () => () => {
      isMountedRef.current = false
    },
    [],
  )

  const handleChange = async (value: boolean) => {
    setIsSaving(true)
    try {
      await onToggle(value)
    } finally {
      if (isMountedRef.current) setIsSaving(false)
    }
  }

  return (
    <div
      className="tw:flex tw:items-center"
      onClick={event => event.stopPropagation()}
    >
      <Switch
        checked={showInMap}
        disabled={isSaving}
        onCheckedChange={handleChange}
      />
    </div>
  )
}

export default observer(ShowInMapCell)
